// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpExitIntentModal-cls1_i3o","cls2":"LoswpExitIntentModal-cls2_vvB LoswpExitIntentModal-cls1_i3o"};